<div class="vflex-300">
  <h2>Phone Number Inputs</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>
      import &#123; PhoneNumberInputComponent &#125; from
      '&#64;spaces-ui/meadow/components/phone-number';
    </code>
  </div>

  <h3>Phone Number Input (value required)</h3>
  <ng-template #requiredInput data-sample="requiredInput">
    <section class="vflex-300 flex-no-stretch">
      <form [formGroup]="formGroup">
        <mdw-phone-number-input formControlName="requiredPhoneNumber"></mdw-phone-number-input>
      </form>

      <div class="hflex-100">
        <p class="bold">Input is valid:</p>
        <p class="secondary">{{ formGroup.controls.requiredPhoneNumber.valid }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="requiredInput" sampleName="requiredInput"></app-sample>

  <h3>Phone Number Input (value optional)</h3>
  <ng-template #optionalInput data-sample="optionalInput">
    <section class="vflex-300 flex-no-stretch">
      <form [formGroup]="formGroup">
        <mdw-phone-number-input
          [requireValue]="false"
          formControlName="optionalPhoneNumber"
        ></mdw-phone-number-input>
      </form>

      <div class="hflex-100">
        <p class="bold">Input is valid:</p>
        <p class="secondary">{{ formGroup.controls.optionalPhoneNumber.valid }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="optionalInput" sampleName="optionalInput"></app-sample>

  <h3>Phone Number Input (disabled)</h3>
  <ng-template #disabledInput data-sample="disabledInput">
    <section class="vflex-300 flex-no-stretch">
      <form [formGroup]="formGroup">
        <mdw-phone-number-input
          [requireValue]="false"
          formControlName="disabledPhoneNumber"
        ></mdw-phone-number-input>
      </form>
    </section>
  </ng-template>
  <app-sample [sampleContent]="disabledInput" sampleName="disabledInput"></app-sample>
</div>
